export const carouselData = [
  {
    title: 'Business Analysis',
    subtitle: 'Strategic Insights & Data-Driven Decisions',
    image: '/images/silde/1.jpg',
    description: 'Transforming complex requirements into actionable strategies'
  },
  {
    title: 'Coding Excellence',
    subtitle: 'Full-Stack Development & Technical Innovation',
    image: '/images/silde/2.jpg',
    description: 'Crafting robust, scalable solutions with modern technologies'
  },
  {
    title: 'Life & Passion',
    subtitle: 'Beyond Work - Embracing Every Moment',
    image: '/images/silde/3.jpg',
    description: 'Balancing professional excellence with personal fulfillment'
  }
];
